import React from 'react';
import { useCountdown } from './hooks/useCountdown';
import { useMetaPixel } from './hooks/useMetaPixel';
import { LogoHeader } from './components/LogoHeader';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { TestimonialsHighlight } from './components/TestimonialsHighlight';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BenefitStrip } from './components/BenefitStrip';
import { ContenidoIncluido } from './components/ContenidoIncluido';
import { BonusesSection } from './components/BonusesSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { TestimonialsExtended } from './components/TestimonialsExtended';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { FooterSection } from './components/FooterSection';
export function App() {
  // Live countdown synced across sections
  const timeLeft = useCountdown(23, 40, 36);

  // Meta Pixel — carga y PageView
  useMetaPixel('1555663492362726');
  return <div className="min-h-screen bg-page text-white font-sans" data-id="element-0" data-mp="3reltuemj9e7n">
      <noscript data-id="element-1" data-mp="4n6o4eeqtbm">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1555663492362726&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="56m9egl55mh" />
      </noscript>

      <LogoHeader data-id="element-3" data-mp="38l8iru2c62iy" />
      <HeroSection data-id="element-4" data-mp="38kqce4lym7xb" />
      <SocialProof data-id="element-5" data-mp="38k6vmr81ppkv" />
      <TestimonialsHighlight data-id="element-6" data-mp="38nupxslbeg0n" />
      <ProblemSection data-id="element-7" data-mp="3dkl0y1i9ilf7" />
      <TomosSection data-id="element-8" data-mp="3dlw5i3jj7x7d" />
      <BonusesSection data-id="element-9" data-mp="3dmfozootytni" />
      <BenefitStrip data-id="element-10" data-mp="3dii4aymltu1i" />
      <ContenidoIncluido data-id="element-11" data-mp="nvstx4mognvy" />
      <CountdownTimer timeLeft={timeLeft} data-id="element-12" data-mp="nuhh6fb985sp" />
      <PricingSection data-id="element-13" data-mp="nxn902b9pls4" />
      <TestimonialsExtended data-id="element-14" data-mp="sudkecc4nt77" />
      <GuaranteeSection data-id="element-15" data-mp="stko65asom3b" />
      <FAQSection data-id="element-16" data-mp="sssq8ntq6c9v" />
      <FinalCTA timeLeft={timeLeft} data-id="element-17" data-mp="swgk5o3310p4" />
      <FooterSection data-id="element-18" data-mp="35oz0whm5evr" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-page/95 backdrop-blur border-t border-white/10 p-3 md:hidden z-50" data-id="element-19" data-mp="38ktuby5znfz">
        <a href="https://megapack-vianda-resuelta.impultienda.ar/checkout" className="cta-btn block w-full text-white text-center font-display font-extrabold text-base uppercase tracking-wide py-3.5 rounded-full" data-id="element-20" data-mp="d4e6rwfspiya">
          🍱 QUIERO MI MEGAPACK
        </a>
      </div>
    </div>;
}